import CourseController from '../diagrams/course.controller';

class CheckboxDiagramController extends CourseController {

  constructor(courseService, diagramService, $translate, $timeout) {
    'ngInject';

    super(courseService, diagramService, $translate);
    this.checkboxes = true;
    this.$timeout = $timeout;

  }

  $onInit() {
    this.diagramId = this.data.id;
    this.userAnswers = this.data.userAnswers;
    this.correctAnswers = this.data.correctAnswers;
  }

  showUserAnswers() {

  }

}

export default CheckboxDiagramController;



// WEBPACK FOOTER //
// ./client/app/components/checkbox-diagram/checkbox-diagram.controller.js